import slider from "./modules/slider";
import dropdown from "./modules/dropdown";
import menuMobile from "./modules/mobile_menu";
import map from "./modules/map";

(function (Drupal, once) {
  Drupal.behaviors.headerBehavior = {
    attach: function(context, settings) {

      const dropdown_elements = once('dropdown-menu_header--menu-main', '.header--menu-main', context);
      dropdown_elements.forEach((element) => {
        dropdown.menu(element);
      })

      const mobile_elements = once('menu-mobile_header--menu-main', '.header--menu-main', context);
      mobile_elements.forEach((element) => {
        menuMobile.init(element, 'header--menu-main');
      })

      const dropdown_search_elements = (
        context.classList && context.classList.contains('header--search')
          ? once('dropdown-init_header--search', ':scope', context)
          : once('dropdown-init_header--search', '.header--search', context)
      );

      dropdown_search_elements.forEach((element) => {
        dropdown.default(element);
      });

      const dropdown_menu_account_elements = (
        context.classList && context.classList.contains('header--menu-account')
          ? once('dropdown-menu_header--menu-account', ':scope', context)
          : once('dropdown-menu_header--menu-account', '.header--menu-account', context)
      );

      dropdown_menu_account_elements.forEach((element) => {
        dropdown.menu(element);
      });


      const slider_banner_element = once('banner', '.header--banner .slider', context);
      slider_banner_element.forEach((element) => {
        slider.banner(element);
      })
    }
  };

  Drupal.behaviors.footerBehavior = {
    attach: function(context, settings) {
      const footer_elements = once('footer-partner', '.footer--partner', context);
      footer_elements.forEach((element) => {
        slider.footerPartner(element);
      })
    }
  };

  Drupal.behaviors.hpBehavior = {
    attach: function (context, settings) {
      const event_elements = once('hp--view-new-n-event', '.hp--view-new, .hp--view-event', context);
      event_elements.forEach((element) => {
        slider.hpNewNEvent(element);
      });

      const job_elements = once('hp--job', '.hp--job', context);
      job_elements.forEach(
        function (elementHtmlTag) {
          slider.hpJob(elementHtmlTag);
        }
      );
    }
  };

  Drupal.behaviors.contactBehavior = {
    attach: function(context, settings) {

      const map_block_elements = once('contact-map', '.block--contact .field--type-geofield', context);
      map_block_elements.forEach((element) => {
        map.geofield(element);
      })

      const map_bundle_elements = once('contact-map', '.node--bundle--contact .field--type-geofield', context);
      map_bundle_elements.forEach((element) => {
        map.geofield(element);
      })
    }
  };

})(Drupal, once);
